<template>
	<v-dialog  
	 	v-model="dialog"
		:fullscreen="fullscreen"
		transition="dialog-bottom-transition"
		scrollable
		persistent
		:max-width="fullscreen? null: maxWidth"
	>
		<!-- Актіватор -->
		<template v-slot:activator="{ on: dialog, attrs }">
			<v-tooltip bottom>
				<template v-slot:activator="{ on: tooltip, attrs }">
					<slot name="activator" :attrs="attrs" :dialog="dialog" :tooltip="tooltip">
						<v-btn icon v-bind="attrs" v-on="{ ...tooltip, ...dialog }">
							<v-icon>mdi-pencil</v-icon>
						</v-btn>
					</slot>
				</template>
				<span>{{ $vuetify.lang.t(`$vuetify.${tooltip}`) | capitalize }}</span>
			</v-tooltip>
		</template>

		<v-card>
			<v-toolbar flat dark color="primary" style="flex: 0 1 auto;">
				<v-avatar>
					<v-icon>{{ icon }}</v-icon>
				</v-avatar>
				<v-toolbar-title>{{ title }}</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-btn icon @click="fullscreen = !fullscreen">
					<v-icon v-if="fullscreen">mdi-arrow-collapse</v-icon>
					<v-icon v-else="fullscreen">mdi-arrow-expand</v-icon>
				</v-btn>
				<v-btn icon @click="dialog=false" >
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>

			<v-card-text>
				 <v-form ref="form" class="mt-3">
					<v-row dense>
						<v-col cols="12">
							<z-number
								v-model.trim="item.number"
								label="Реєстраційний номер"
								outlined dense
								identification
								:rules="[rules.atLeastOne]"
								@identification="identification"
							></z-number>
						</v-col>
						<v-col cols="12">
							<z-vin
								v-model.trim="item.vin"
								label="VIN-код"
								outlined dense
								identification
								:rules="[rules.atLeastOne]"
								@identification="identification"
							></z-vin>
						</v-col>
						<v-col cols="12">
							<z-category
								v-model="item.category"
								label="Категорія"
								outlined dense
								clearable
							></z-category>
						</v-col>
						<v-col cols="12">
							<z-brand
								v-model="item.brand"
								label="Марка"
								:category="item.category"
								outlined dense
							></z-brand>
						</v-col>
						<v-col cols="12">
							<z-model
								v-model="item.model"
								label="Модель"
								:category="item.category"
								:brand="item.brand"
								:rules="[rules.atLeastOne]"
								outlined dense
							></z-model>
						</v-col>
						<v-col cols="12">
							<z-generation
								v-model="item.generation"
								label="Покоління"
								:brandmodel="item.model"
								outlined dense
							></z-generation>
						</v-col>
						<v-col cols="12">
							<z-modification
								v-model="item.modification"
								label="Модифікація"
								:generation="item.generation"
								outlined dense
							></z-modification>
						</v-col>
						<v-col cols="12">
							<z-year
								v-model="item.yearProd"
								label="Рік випуску"
								:generation="item.generation"
								outlined dense
							></z-year>
						</v-col>
						<v-col cols="12">
							<z-driver
								v-model="item.driver"
								label="Тип приводу"
								:category="item.category"
								outlined dense
							></z-driver>
						</v-col>
						<v-col cols="12">
							<v-text-field
								v-model="item.engineVolume"
								label="Об'єм двигуна, л."
								outlined dense
								type="number"
								hide-details="auto"
								:min="0"
								:max="10"
							></v-text-field>
						</v-col>
						<v-col cols="12">
							<z-fuel
								v-model="item.fuel"
								label="Тип палива"
								:category="item.category"
								outlined dense
							></z-fuel>
						</v-col>
						<v-col cols="12">
							<z-gearbox
								v-model="item.gearbox"
								label="Коробка передач"
								:category="item.category"
								outlined dense
							></z-gearbox>
						</v-col>
						<v-col cols="12">
							<z-color
								v-model="item.color"
								label="Колір"
								outlined dense
							></z-color>
						</v-col>
						<v-col cols="12">
							<v-text-field
								v-model="item.odometer"
								label="Показник одометра, км"
								outlined dense
								type="number"
								hide-details="auto"
								min="0"
							></v-text-field>
						</v-col>
						<v-col cols="12">
							<v-textarea
								v-model="item.description"
								label="Коментар"
								outlined
								dense
								hide-details="auto"
								rows="2"
							></v-textarea>
						</v-col>
					</v-row>
				 </v-form>
			</v-card-text>
			<v-card-actions>
				<v-btn text @click.native="onClear">{{ $vuetify.lang.t('$vuetify.clear') }}</v-btn>
				<v-spacer></v-spacer>
				<v-btn text @click.native="onCancel">{{ $vuetify.lang.t('$vuetify.cancel') }}</v-btn>
				<v-btn color="success" dark @click.native="onOK">{{ $vuetify.lang.t('$vuetify.ok') }}</v-btn>
			</v-card-actions>
		</v-card>

		<v-overlay :value="loading">
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay>
	</v-dialog>
</template>

<script>
import axios from 'axios'
import mixin from './mixin/main'
import { mapGetters, mapActions } from 'vuex'
//import zForm from '@/views/forms/vehicle.parameters.park'

import zNumber from '@/views/components/controls/textfield/VehicleNumber'
import zVin from '@/views/components/controls/textfield/VehicleVIN'
import zCategory from '@/views/components/controls/select/VehicleCategory'

//import zCategory from '@/views/components/controls/combobox/VehicleCategory'
import zBrand from '@/views/components/controls/combobox/VehicleBrand'
import zModel from '@/views/components/controls/combobox/VehicleBrandModel'
import zGeneration from '@/views/components/controls/combobox/VehicleGeneration'
import zModification from '@/views/components/controls/combobox/VehicleModification'
import zYear from '@/views/components/controls/combobox/VehicleYear'
import zDriver from '@/views/components/controls/combobox/VehicleDriver'
import zFuel from '@/views/components/controls/combobox/VehicleFuel'
import zGearbox from '@/views/components/controls/combobox/VehicleGearbox'
import zColor from '@/views/components/controls/combobox/VehicleColor'



export default {
	name: 'DialogDetailVehicle',
	mixins: [mixin],
	components: { zNumber, zVin, zCategory, zBrand, zModel, zGeneration, zModification, zYear, zDriver, zFuel, zGearbox, zColor },
	data: () => ({
		item: {},
	}),

	props: {
		title: 				{ type: String, default: 'Транспортний засіб' },
		icon: 				{ type: String, default: 'mdi-car' },
		maxWidth: 			{ type: Number, default: 480 },
	},

	computed: {
		//...mapGetters('Vehicle', [ 'item' ]),

		id() {
			return this.item?.id ? this.item.id : null
		},
	},

	created () {
		//console.log(this.$options.name, 'created')
	},

	mounted() {
		this.rules['atLeastOne'] = () => {
			//console.log('atLeastOne', 'this', this)

			const number = !!this.item?.number;
			const vin = !!this.item?.vin;
			const model = !!this.item?.model;
			
			if (!number && !vin && !model) {
				return 'Заповніть хоча б одне з полів (Реєстраційний номер або VIN-код або Модель)';
			}
			return true;
		}
	},

	methods: {
		//...mapActions('Vehicle', [ 'setItem' ]),
		
		onOpen () {
			//console.log(this.$options.name, 'onOpen','selected', this.selected)

			this.item = {};

			if(this.selected) {
				this.item = { ...this.selected };

				//console.log(this.$options.name, 'onOpen','item', this.item)
			}

			//console.log(this.$options.name, 'onOpen','item', this.item)

			/* this.setItem();

			if(this.selected) {
				this.setItem({...this.selected});
			} */
		},

		onClear() {
			this.$refs.form.reset()
			//this.clear()
		},

		onOK() {
			//console.log(this.$options.name, 'onOK', 'item', this.item)
			if(this.$refs.form.validate()) {
				this.$emit('ok', {...this.item})
				this.dialog = false
			}
			/* if(this.$refs.form.validate()) {
				if(this.selected) {
					//this.selected = {...this.item}
					this.$emit('edit', {...this.item})
				} else {
					this.$emit('add', {...this.item})
				}

				this.dialog = false
			} */
		},

		/**
		 * Ідентифікація ТЗ за номером або vin-кодом
		 * 
		 * @param item 
		 */
		identification(vinnumber) {
			if(vinnumber) {
				axios.get(`/vehicle/identification/${vinnumber}`).then(response => {
					//console.log(this.$options.name, 'identification','response.data', response.data)
	
					if(response.data?.favorit) {
						if(response.data?.favorit?.number) this.item.number = response.data.favorit.number;
						if(response.data?.favorit?.vin) this.item.vin = response.data.favorit.vin;
						if(response.data?.favorit?.brand) this.item.brand = response.data.favorit.brand;
						if(response.data?.favorit?.model) this.item.model = response.data.favorit.model;
						if(response.data?.favorit?.yearProd) this.item.yearProd = response.data.favorit.yearProd;
						if(response.data?.favorit?.color) this.item.color = response.data.favorit.color;
						if(response.data?.favorit?.fuel) this.item.fuel = response.data.favorit.fuel;
						if(response.data?.favorit?.engineVolume) this.item.engineVolume = response.data.favorit.engineVolume;
					}
				}, error => {
					console.log(error)
				}).finally(() => { this.loading = false });
			}
		},
	},
}
</script>